import { observer } from "mobx-react";
import ContentState from "../../../../stores/ContentState";
import "./index.scss";
import MissionImage from "../MissionImage";
import MissionList from "../MissionList";
import { useInView } from "react-intersection-observer";
import classNames from "classnames";
const Intro = () => {
  const { ref, inView, entry } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });
  const { intro } = ContentState.mission;
  if (!intro) return <></>;

  //const title = intro?.title.split(" ");

  return (
    <section className={classNames("mission-intro", inView && "animated")}>
      <div className="mission-intro__top">
        <span className="mission-intro__subtitle">{intro?.subtitle}</span>
        <h1 className={classNames("mission-intro__title")} ref={ref}>
          <span className="anim-block" dangerouslySetInnerHTML={{ __html: intro?.title }}></span>
        </h1>
      </div>
      <MissionImage src={intro?.src} />
      <div className={classNames("mission-intro__block_photo_text", inView && "animated")} >
        <span  dangerouslySetInnerHTML={{ __html: intro?.text_photo }}></span>
      </div>
      <div className="mission-intro__block">
        <MissionList
          block={{
            listTitle: intro?.listTitle,
            list: intro?.list,
          }}
        />
      </div>
    </section>
  );
};

export default observer(Intro);
// {
//   title?.map((c: any, i: number) => (
//     <span
//       style={{
//         overflow: "hidden",
//       }}
//     >
//       <span
//         className="anim-block"
//         key={i}
//         style={{
//           transitionDelay: (i + 1) * 0.2 + "s",
//         }}
//       >
//         {c}{" "}
//       </span>
//     </span>
//   ));
// }
